angular.module('notifications')

    .controller('PushNotificationsCtrl', ['$scope', '$uibModalInstance', '$uibModal', '$http', 'options', 'Restangular', '$filter', 'LoginService', 'modalService', 'logService',
        function ($scope, $uibModalInstance, $uibModal, $http, options, Restangular, $filter, LoginService, modalService, logService) {

        $scope.notification = options.params;
        logService.debug("hhsfjhsaklfas�saf�a")
        logService.debug(options.params);
        logService.debug($scope);
        logService.debug($scope.notification);
        $scope.notificationTypes = [];

        let loadCombos = function () {
            Restangular.all('PushNotifications/Types').getList().then(function (notificationsTypes) {
                logService.debug(notificationsTypes);
                $scope.notificationTypes = notificationsTypes;
            });
        }

        loadCombos();

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.onAccept = function () {
            logService.debug($scope.notification);
            Restangular.all('PushNotifications').post($scope.notification).then(function (result) {
                logService.debug(result);
            });
            $uibModalInstance.close();
        };
    }])

;
        
